import UpdateDistributaryZone from "../components/configuration/DistributaryZone/UpdateDistributaryZone";

const UpdateDistrbutoryZonepage = () => {
    return (
        <UpdateDistributaryZone />
    );
};  

export default UpdateDistrbutoryZonepage;
